import React, { useState, useMemo } from 'react'
import styled, { withTheme } from 'styled-components'
import { get } from 'lodash'
import Iconfont from '../Iconfont'
import { setLanguageStore, getLanguageStore } from '../storage'

const languages = [
  { value: 'cn', name: '中文' },
  { value: 'en', name: 'EN ' },
]
const languagesMap = languages.reduce((acc, cur) => {
  acc[cur.value] = cur
  return acc
}, {})

const Language = styled.li`
  display: inline-block;
  padding: 0 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e1e6ee;
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  color: #17233d;
  font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
  cursor: pointer;
  margin-top: 8px;

  .tnt-icon {
    font-size: ${({ theme: { size } }) => (size === 'large' ? '24px' : '20px')};
    margin-right: 4px;
  }

  span {
    position: relative;
    font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
    top: ${({ theme: { size } }) => (size === 'large' ? '-3px' : '-2px')};
    font-family: auto;
  }

  .isInIframe & {
    display: none;
  }
`

export default withTheme((props) => {
  const { onChange } = props
  const getLanguage = () => {
    let lang = getLanguageStore() || props.language

    if (!languagesMap[lang]) {
      lang = get(languages, '0.value')
    }

    return lang
  }
  const [language = 'cn', setLanguage] = useState(getLanguage())
  const switchLanguage = () => {
    const lang = language !== 'en' ? 'en' : 'cn'

    setLanguage(lang)
    setLanguageStore(lang)
    onChange && onChange(lang)
  }

const otherLanguage = useMemo(()=> language === 'cn' ? 'en' : 'cn',[language]);

  return (
    <Language onClick={switchLanguage}>
      <Iconfont type={`flag-${otherLanguage}`} />
      <span>{get(languagesMap[otherLanguage], 'name')}</span>
    </Language>
  )
})
